/**
 *  BaseTile
 *
 *  Created by Legman on 13/03/2017.
 *
 */

import Actor    from "./Actor";
import Common   from "./Common";

/**
 * @class
 */
export default class BaseTile extends Actor {
    /**
     * @param {PIXI.Texture} [texture]
     */
    constructor(texture) {
        super(texture);

        /**
         * @member {Array.<PIXI.Sprite>}
         * @private
         */
        this._lights = [];
    }

    /**
     * @param {boolean} [destroyChildren]
     */
    destroy(destroyChildren) {
        for (let i = 0; i < this._lights; ++ i) {
            let light = this._lights[i];
            TweenMax.killTweensOf(light);
        }
        this._lights.length = 0;

        super.destroy(destroyChildren);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createLight() {
        const assets = Common.assets;
        const textures = ["side_light_001", "side_light_002", "side_light_003"];

        const light = new PIXI.Sprite(assets.getTexture(textures[Math.floor(Math.random() * textures.length)]));
        light.alpha = 0.2 + Math.random() * 0.2;
        light.blendMode = PIXI.BLEND_MODES.ADD;
        light.anchor.y = 0.5;
        this.addChild(light);
        this._lights.push(light);

        const duration = 1 + Math.random() * 2;
        const delay = Math.random();

        TweenMax.to(light, duration, {
            delay: delay,
            alpha: 0.14,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });

        return light;
    }
}
